/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import Minting from "../../hooks/Minting";
import "./mint.scss";
import { useWeb3React } from "@web3-react/core";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CheckMint from "../../hooks/minted";
// import Loader from "../../hooks/loader";
import CheckWhiteOne from "../../hooks/checkWhitelist";
import CheckWhiteTwo from "../../hooks/whiteList2";
import Footer from "../landing/footer/Footer";

const Mint = () => {
  const { account } = useWeb3React();
  const { WhiteOne } = CheckWhiteOne();
  const { WhiteTwo } = CheckWhiteTwo();
  const [minted, setMinted] = useState(0);
  const [toMint, setToMint] = useState(1);
  const [whitePhase, setWhitePhase] = useState(0);
  const [inProcess, setInProcess] = useState(false);
  const [mainLoader, setMainLoader] = useState(false);
  const [white, setWhite] = useState(false);
  const { userMinting } = Minting();
  const { minte } = CheckMint();
  let address = require("../../hooks/wallet1.json");
  let address2 = require("../../hooks/wallet2.json");

  const Subtract = () => {
    if (toMint > 0) {
      setToMint(toMint - 1);
    }
  };

  useEffect(async () => {
    const res = await WhiteOne();
    if (res === false) {
      const res0 = await WhiteTwo();
      if (res0 === false) {
        setWhitePhase(2);
      } else {
        setWhitePhase(0);
      }
    } else {
      setWhitePhase(1);
    }
  }, [whitePhase]);

  useEffect(() => {
    if (whitePhase !== 0 && account) {
      if (whitePhase === 1) {
        let status = address.find((i) => {
          return i === account;
        });
        if (status) {
          setWhite(true);
        } else {
          setWhite(false);
        }
      } else if(whitePhase === 2) {
        let status = address2.find((i) => {
            return i === account;
          });
          if (status) {
            setWhite(true);
          } else {
            setWhite(false);
          }
      }
    }
  }, [whitePhase]);

  const Add = () => {
    if (toMint < 8) {
      setToMint(toMint + 1);
    }
  };

  const startMinting = async () => {
    if (account && toMint > 0) {
      setMainLoader(true);
      const res = await userMinting(toMint);
      if (res?.code === 4001) {
        await setMainLoader(false);
      } else if (res?.code) {
        await setMainLoader(false);
        // await toast.error("Transaction failed!");
      } else {
        // await toast.success("Tokens Staked!");
        await setMainLoader(false);
      }
    } else {
    }
  };

  useEffect(async () => {
    const res = await minte();
    await setMinted(res);
  }, []);

  return (
    <>
      {/* {mainLoader && <Loader />} */}
      <div className="brdr"></div>
      <section className="main-banner-mint" id="aboutus">
        <div className="container p-0">
          <div className="row ptb">
            <div className="col-sm-12">
              <div className="inner-img text-center">
                <h2 className="white ptb20">
                  MINT YOUR
                  <span className="rebort text-uppercase"> DRIVEN NFT </span>
                </h2>
                {/* <p className="grey pt20 ">
                  Sed ut perspiciatis unde omnis iste natus voluptatem{" "}
                </p>
                <p className="grey">
                  accusantium doloremque totam rem aperiam.
                </p> */}
                {/* <p className="grey">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium <br /> doloremque laudantium, totam rem aperiam eaque ipsa.</p> */}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 order-lg-0 order-1">
              <div className=" container p-0 card fullcard ptb20">
                <h2 className=" white text-center mt-4 ">MINT YOUR NFT</h2>
                <p className="grey text-center pt-1"> {minted} NFTs Minted</p>
                <ul className="list-inline text-center ptb20">
                  <li className="list-inline-item">
                    <div className="inner-side w-25">
                      <button
                        onClick={() => Subtract()}
                        className="for-btn "
                        type="button"
                      >
                        -
                      </button>
                    </div>
                  </li>
                  <li className="list-inline-item">
                    <div className="inner-side">
                      <input
                        type="text"
                        disabled
                        value={toMint}
                        className="form-control placeholder"
                        placeholder="1"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                      />
                    </div>
                  </li>
                  <li className="list-inline-item">
                    <div className="inner-side">
                      <button
                        onClick={() => Add()}
                        className="for-btn"
                        type="button"
                      >
                        +
                      </button>
                    </div>
                  </li>
                </ul>
                <div className="gray ptb10 text-center">
                  <p className=" grey text-center ptb20">
                    {" "}
                    <span className="white">Total:</span> {0.08 * toMint} ETH
                  </p>
                </div>
                <ul className="list-inline ptb20 text-center ">
                  <li className="list-inline-item">
                    <button
                      disabled={white !== true}
                      className="btn-common w-100 px-5"
                      onClick={() => startMinting()}
                    >
                      Mint{" "}
                    </button>
                  </li>
                </ul>
                <ul className="list-inline ptb20 text-center ">
                  <li className="list-inline-item">
                    <button className={white?'btn-common w-100v bg-success px-5':'btn-common bg-danger w-100 px-5'}>
                      {white ? "Whitelisted" : "Not Whitelisted"}
                    </button>
                  </li>
                </ul>
                <div className="brdr mt-5"></div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="inner-addresses">
                      <div className="gray  ptb20">
                        <p className=" grey "> NFT Contract Address</p>
                        <a className=" white d-flex w-100 text-truncate">
                          <img className="mr-2 img-fluid" src="path1.png" />{" "}
                          0x0B8Ff1c7b1998aed71A2971a4facB6d90E6851aA
                        </a>
                      </div>
                      <div className="brdr"></div>
                      <div className="gray ptb20">
                        <p className=" grey "> Your Wallet Address</p>
                        <a className="white">
                          <img src="metamask1.png" className="mr-2 img-fuild" />{" "}
                          {account}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 my-auto d-lg-block d-none">
              <div className="inner-content text-center">
                <div className="inner-img">
                  <img
                    src="group18.png"
                    className="img-fluid ml-md-5 roboImg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </>
  );
};

export default Mint;
